import { BrandAsset, Text, useColors } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { Trans } from "react-i18next";

export function AppFooter() {
  const colors = useColors();
  return (
    <>
      <div
        className={css({
          display: "flex",
          gap: "var(--space-4)",
        })}
      />
      <Text color="text-weak" testID="footer-powered-by-link">
        <Trans>
          Powered by{" "}
          <BrandAsset
            height="18"
            width="62"
            type="full"
            brand="certn"
            fill={colors["icon-base"]}
            className={css({ verticalAlign: "middle" })}
          />
        </Trans>
      </Text>
    </>
  );
}
